import { addToDebugData } from '@wix/package-picker-shared';
import { extractAppIntentCreativeFromDealerOffers } from '../dealer.utils';
export const getDealerIntentQueryFn = async _ref => {
  let {
    httpClient,
    request
  } = _ref;
  const {
    placementId,
    siteId,
    siteAuthorizationType
  } = request;
  const {
    DealerApiClient
  } = await import('../dealer.api-client');
  const {
    listOffers
  } = DealerApiClient.queries({
    httpClient
  });
  const offers = await listOffers({
    placementId,
    siteId,
    siteAuthorizationType
  });
  addToDebugData({
    dealerIntent: {
      offers,
      request
    }
  });
  const creative = extractAppIntentCreativeFromDealerOffers(offers);
  return {
    intent: (creative == null ? void 0 : creative.intent) ?? undefined,
    title: creative == null ? void 0 : creative.business
  };
};
//# sourceMappingURL=getDealerIntent.query.js.map